<template>
  <div>
    <div class="wrapper">
      <header class="wrapper__header">
        <h2 v-html="$t(`${namespace}.${timePolicyType}.title`)" class="wrapper__header__title" />
        <p v-html="$t(`${namespace}.${timePolicyType}.description`)" class="wrapper__header__text" />
      </header>

      <div class="wrapper__body">
        <Selects
          :timePolicyType="timePolicyType"
          :intervals="intervals"
          :submit="submit"
          :kind="kind"
          @renderLabels="renderLabels"
        />
      </div>
    </div>

    <Labels
      :timePolicyType="timePolicyType"
      :intervals="intervals"
      :setLabels="setLabels"
      remove
      @removeTimeRange="removeTimeRange"
    />
  </div>
</template>

<script>
import { isArray } from 'utils/functions'
import Selects from 'components/usagePolicy/timeRangeComboBox/Selects'
import Labels from 'components/usagePolicy/timeRangeComboBox/Labels'

export default {
  name: 'TimeRangeComboBox',
  props: {
    timePolicyType: {
      type: String,
      required: true
    },
    intervals: {
      type: Array,
      required: true
    },
    submit: {
      type: Boolean
    },
    kind: {
      type: String
    }
  },
  components: {
    Selects,
    Labels
  },
  data () {
    return {
      namespace: 'Views.UsagePolicyPage.timeRangeComboBox',
      setLabels: false
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    },

    renderLabels (arr) {
      this.$emit('updateIntervals', arr)
    },

    removeTimeRange (val) {
      this.$emit('removeTimeRange', val)
    },

    toggleSetLabels () {
      this.setLabels = !this.setLabels
    }
  },
  watch: {
    intervals: {
      deep: true,
      handler (from = [], to = []) {
        if (from.length !== to.length) {
          this.toggleSetLabels()
        }
      }
    }
  },
  mounted () {
    this.toggleSetLabels()
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: $gray-2;
  padding: 24px 24px 0;
}

.wrapper__header__title {
  color: $gray-8;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;

  span {
    color: $accent;
  }
}

.wrapper__header__text {
  color: $gray-6
}

.wrapper__body {
  padding: 0 24px;
}
</style>
